module.exports = __webpack_public_path__ + "img/Group 1504775918.7105c9d3.svg";